import { createRouter, createWebHistory } from 'vue-router';
import { usePermissions } from '../../auth/composables/permissions';
import { authRoutes } from '../../auth/routes/auth-routes';
import { userRoutes } from '../../user/routes/user-routes';
import { accountRoutes } from '../../account/account/routes/account-routes';
import { eventRoutes } from '../../event/event/routes/event-routes';
import { leagueRoutes } from '../../league/league/routes/league-routes';
import { profileRoutes } from '../../profile/profile/routes/profile-routes';
import { standingRoutes } from '../../standing/standing/routes/standing-routes';
import { speciesRoutes } from '../../species/routes/species-routes';
import NotFound from '../views/NotFoundView.vue';

const defaultRoutes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'event.list' },
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/HelpView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
  },
];

let allRoutes = [];
allRoutes = allRoutes.concat(
  defaultRoutes,
  accountRoutes,
  authRoutes,
  eventRoutes,
  leagueRoutes,
  profileRoutes,
  speciesRoutes,
  standingRoutes,
  userRoutes,
);

const routes = allRoutes;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  linkActiveClass: 'active-parent',
  linkExactActiveClass: 'active',
});

/**
 * Authentications navigation gaurd
 */
router.beforeEach(async (to) => {
  const { isAllowedAsync } = usePermissions();

  if (!(await isAllowedAsync(to.name))) {
    console.error('403 - Not allowed');
    return { name: 'access' };
    //return false;
  }
  // if (to.meta.requiresAuth && !loggedIn) {
  //   return { name: 'login' };
  // }
});

export default router;
